import React from 'react';

import { useIntl } from 'react-intl';

import { Box, Text } from '@atlaskit/primitives/compiled';
import { FireTrackAnalytics } from '@atlassian/analytics-bridge';
import { Action, ActionSubject } from '@atlassian/proforma-utilities/analytics';

import type { FormFieldComponentRendererProps } from '../../../../../../../common/types/renderers';
import { messages } from './messages';

export const UnknownRenderer = ({
	fieldId,
}: FormFieldComponentRendererProps): React.JSX.Element => {
	const intl = useIntl();

	return (
		<Box testId="unknown-renderer">
			<Text color="color.text.danger">{intl.formatMessage(messages.unknownFieldType)}</Text>
			<FireTrackAnalytics
				actionSubject={ActionSubject.FORM_FIELD}
				action={Action.FAILED}
				actionSubjectId="proformaFormRenderer"
				attributes={{ fieldId, isUnknownRenderer: true }}
			/>
		</Box>
	);
};
